/**
 * @congress/platform-helpers v3.0.0
 * @version 3.0.0
 * @license CYIM: www.cyim.com
 */

import { ApolloLink, Observable } from '@apollo/client/core';
import { createClient } from 'graphql-ws';
import { print } from 'graphql';

/**
 * Link implementation based on: https://github.com/enisdenjo/graphql-ws#user-content-apollo-client
 */

class WebSocketLink extends ApolloLink {
  constructor(options) {
    super();
    this.client = createClient(options);
  }
  request(operation) {
    return new Observable(sink => {
      return this.client.subscribe({
        ...operation,
        query: print(operation.query)
      }, {
        next: sink.next.bind(sink),
        complete: sink.complete.bind(sink),
        error: err => {
          if (err instanceof Error) {
            return sink.error(err);
          }
          if (err instanceof CloseEvent) {
            return sink.error(
            // reason will be available on clean closes
            new Error(`Socket closed with event ${err.code} ${err.reason || ""}`));
          }
          return sink.error(new Error(err.map(_ref => {
            let {
              message
            } = _ref;
            return message;
          }).join(", ")));
        }
      });
    });
  }
  async dispose() {
    if (this.client) {
      await this.client.dispose();
    }
  }
}
export { WebSocketLink as default };
//# sourceMappingURL=WebSocketLink.js.map
